import script from "./TestPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./TestPage.vue?vue&type=script&setup=true&lang=ts"

import "./TestPage.vue?vue&type=style&index=0&id=00336bbe&lang=scss"

const __exports__ = script;

export default __exports__